import React from "react";
import { Select } from "antd";
import { getAllAvailableSourceTypes } from "./SourceFilterUtils";

const { Option } = Select;

export interface SourceFilterDropdownProps {
	value: string[];
	onChange: (sourceTypes: string[]) => void;
	className?: string;
	placeholder?: string;
	isDickerDataEnabled: boolean;
	style?: React.CSSProperties;
}

export interface SourceTypeOption {
	label: string;
	value: string[];
	key: string;
}

const SourceFilterDropdown: React.FC<SourceFilterDropdownProps> = ({
	value,
	onChange,
	className = "",
	placeholder = "Select source type",
	isDickerDataEnabled,
	style
}) => {
	const getSourceTypeOptions = (): SourceTypeOption[] => {
		const allSources = getAllAvailableSourceTypes(isDickerDataEnabled);

		const baseOptions: SourceTypeOption[] = [
			{
				label: "All",
				value: allSources,
				key: "all"
			},
			{
				label: "Global (Formerly Etilize)",
				value: ["icecat"],
				key: "icecat"
			},
			{
				label: "Self Catalog",
				value: ["self_catalog"],
				key: "self_catalog"
			},
			{
				label: "Custom Distributor",
				value: ["custom_distributor"],
				key: "custom_distributor"
			}
		];

		if (isDickerDataEnabled) {
			baseOptions.push({
				label: "Dicker Data",
				value: ["dicker_data"],
				key: "dicker_data"
			});
		}

		return baseOptions;
	};

	const getSelectedOptionKey = (): string => {
		const options = getSourceTypeOptions();
		const selectedOption = options.find(
			option =>
				JSON.stringify([...option.value].sort()) ===
				JSON.stringify([...value].sort())
		);
		return selectedOption?.key || "all";
	};

	const handleChange = (selectedKey: string) => {
		const options = getSourceTypeOptions();
		const selectedOption = options.find(
			option => option.key === selectedKey
		);
		if (selectedOption) {
			onChange(selectedOption.value);
		}
	};

	const sourceTypeOptions = getSourceTypeOptions();
	const selectedKey = getSelectedOptionKey();

	return (
		<Select
			value={selectedKey}
			onChange={handleChange}
			className={className}
			placeholder={placeholder}
			style={style ?? { width: "100%" }}
			dropdownStyle={{ minWidth: "200px" }}
		>
			{sourceTypeOptions.map(option => (
				<Option key={option.key} value={option.key}>
					{option.label}
				</Option>
			))}
		</Select>
	);
};

export default SourceFilterDropdown;
